import moment from 'moment';

import {
	cloneDeep
} from 'lodash';

import {
	EventBus
} from '@/support/event-bus';

import Http from '@/support/http';
import S from '@/support/string';
import toastr from '@/support/toastr';

export default {
	getAgenda(context, payload) {

		if (payload && payload.userId && payload.studentId && payload.date) {

			const {
				userId,
				studentId,
				date
			} = payload;

			const route = `v2/agenda/user/${ userId }?studentId=${ studentId }&date=${ date }`;

			return Http.get(route).then((response) => {

				if (!response.data.additionalMeals) {
					response.data.additionalMeals = [];
				}

				if (!response.data.sleepy) {
					response.data.sleepy = [];
				}

				if (!response.data.evacuation) {
					response.data.evacuation = [];
				}

				if (!response.data.eventualMedicines) {
					response.data.eventualMedicines = [];
				}

				if (!response.data.questions) {
					response.data.questions = [];
				}

				if (!response.data.replacementItens) {
					response.data.replacementItens = [];
				}

				context.commit('SET_AGENDA', response.data);

				return response;

			});

		}

	},
	getAgendaStatus(context, payload) {

		if (payload && payload.userId && payload.schoolClassId && payload.date) {

			const {
				userId,
				schoolClassId,
				date
			} = payload;

			const route = `v2/agenda/schoolClass/${ schoolClassId }/day/${ date }/user/${ userId }/status`;

			return Http.get(route).then((response) => {

				context.commit('SET_STUDENT_STATUS', response.data);
				return response;

			});

		}

	},
	saveAgenda(context) {

		if (!context.getters.getAgendaCompletionStatus.eventualMedicine) {
			return toastr.warning('Há itens não incluídos no bloco de medicação eventual.');
		}

		if (!context.getters.getAgendaCompletionStatus.nap) {
			return toastr.warning('Há itens não incluídos no bloco de soneca.');
		}

		if (!context.getters.getAgendaCompletionStatus.evacuation) {
			return toastr.warning('Há itens não incluídos no bloco de evacuação.');
		}

		if (!context.getters.getAgendaCompletionStatus.additionalMeal) {
			return toastr.warning('Há itens não incluídos no bloco de alimentos adicionais.');
		}

		const payload = {};

		const {
			getLoggedUser: user,
			getStudent: student,
			getAgenda: agenda,
			getClass: klass
		} = context.getters;

		let date = context.getters.getAgendaDate;
		date = (typeof date === 'string' ? date : date.toISOString());

		const route = `v2/agenda/user/${ user.id }/student/${ student.studentId }/date/${ date.split('T')[0] }`;

		function getClassLevel(level) {

			return {
				'Bercario': 'KID',
				'Infantil': 'KID',
				'Fundamental_1': 'CHILD',
				'Fundamental_2': 'YOUNG',
				'EnsinoMedio': 'TEEN',
				'Universitario': ''
			}[level];

		}

		const classLevel = getClassLevel(klass.schoolClassLevel);

		delete agenda.creationDateTime;
		delete agenda.updateUserLog;

		payload.type = classLevel;
		payload[`agenda${ S.capitalize(classLevel) }`] = agenda;

		return Http.post(route, payload).then((response) => {

			toastr.success('Agenda salva com sucesso!');

			context.commit('SET_AGENDA', response.data);

			context.commit('PUT_COMPLETION_STATUS', {
				key: 'eventualMedicine',
				value: true
			});

			context.commit('PUT_COMPLETION_STATUS', {
				key: 'nap',
				value: true
			});

			context.commit('PUT_COMPLETION_STATUS', {
				key: 'evacuation',
				value: true
			});

			context.commit('PUT_COMPLETION_STATUS', {
				key: 'additionalMeal',
				value: true
			});

			EventBus.$emit('agendaSaved', response.data);

			return response;

		});

	},
	publishAgenda(context) {

		const {
			getLoggedUser: user,
			getStudent: student,
			getClass: klass
		} = context.getters;

		let date = context.getters.getAgendaDate;
		date = (typeof date === 'string' ? date : date.toISOString());

		const route = `v2/agenda/user/${ user.id }/publish`;

		return Http.post(route, {
			schoolClassId: klass.schoolClassId,
			studentId: student.studentId,
			date: date.split('T')[0]
		}).then((response) => {

			context.commit('SET_AGENDA', response.data);
			toastr.success('Agenda publicada com sucesso!');

			EventBus.$emit('agendaPublished', response.data);

			return response;

		});

	},
	publishAllAgendas(context) {

		const {
			getLoggedUser: user,
			getClass: klass
		} = context.getters;

		let date = context.getters.getAgendaDate;
		date = (typeof date === 'string' ? date : date.toISOString());

		const route = `v2/agenda/user/${ user.id }/publish-all`;

		return Http.post(route, {
			schoolClassId: klass.schoolClassId,
			date: date.split('T')[0]
		}).then((response) => {

			context.commit('SET_AGENDA', response.data);
			toastr.success('Agendas publicadas com sucesso!');

			EventBus.$emit('agendaPublishedAll', response.data);

			return response;

		});

	},
	putAgendaDate(context, payload) {
		context.commit('PUT_AGENDA_DATE', payload);
	},
	putAgendaWater(context, payload) {
		context.commit('PUT_AGENDA_WATER', payload.target.value);
	},
	putAgendaHumor(context, payload) {
		context.commit('PUT_AGENDA_HUMOR', payload.target.value);
	},
	putAgendaUrine(context, payload) {
		context.commit('PUT_AGENDA_URINE', payload.target.value);
	},
	putAgendaBrush(context, payload) {
		context.commit('PUT_AGENDA_BRUSH', payload.target.value);
	},
	putAgendaBathQuantity(context, payload) {
		context.commit('PUT_AGENDA_BATH_QUANTITY', payload.target.value);
	},
	putAgendaDiaperQuantity(context, payload) {
		context.commit('PUT_AGENDA_DIAPER_QUANTITY', payload.target.value);
	},
	putAgendaMealPortion(context, payload) {

		context.commit('PUT_AGENDA_MEAL_PORTION', {
			index: parseInt(payload.target.dataset.index),
			value: payload.target.value
		});

	},
	putAgendaBeveragePortion(context, payload) {

		context.commit('PUT_AGENDA_BEVERAGE_PORTION', {
			index: parseInt(payload.target.dataset.index),
			value: payload.target.value
		});

	},
	postAgendaAdditionalMealsItem(context, payload) {

		if (payload.time.length === 5) {
			payload.time = `${ payload.time }:00`;
		}

		context.commit('POST_AGENDA_ADDITIONAL_FOOD_ITEM', payload);

	},
	putAgendaAdditionalMealsItem(context, payload) {

		if (payload.time.length === 5) {
			payload.time = `${ payload.time }:00`;
		}

		context.commit('PUT_AGENDA_ADDITIONAL_FOOD_ITEM', payload);

	},
	deleteAdditionalMealsItem(context, payload) {
		context.commit('DELETE_ADDITIONAL_MEALS_ITEM', payload);
	},
	putAgendaScheduledMedicine(context, payload) {

		context.commit('PUT_AGENDA_SCHEDULED_MEDICINE', {
			index: payload.target.dataset.index,
			value: payload.target.checked
		});

	},
	putAgendaObservation(context, payload) {
		context.commit('PUT_AGENDA_OBSERVATION', payload.target.value);
	},
	putAgendaActivities(context, payload) {

		context.commit('PUT_AGENDA_ACTIVITIES', {
			index: payload.target.dataset.index,
			value: payload.target.checked
		});

	},
	putAgendaParticipation(context, payload) {
		context.commit('PUT_AGENDA_PARTICIPATION', payload.target.value);
	},
	putAgendaPresence(context, payload) {
		context.commit('PUT_AGENDA_PRESENCE', payload.target.value);
	},
	postAgendaQuestions(context, payload) {

		context.commit('POST_AGENDA_QUESTIONS', {
			index: payload.target.dataset.index,
			value: payload.target.value
		});

	},
	putAgendaQuestions(context, payload) {

		context.commit('PUT_AGENDA_QUESTIONS', {
			index: payload.target.dataset.index,
			value: payload.target.value
		});

	},
	deleteNapItem(context, payload) {
		context.commit('DELETE_NAP_ITEM', payload);
	},
	deleteEvacuationItem(context, payload) {
		context.commit('DELETE_EVACUATION_ITEM', payload);
	},
	deleteEventualMedicineItem(context, payload) {
		context.commit('DELETE_EVENTUAL_MEDICINE_ITEM', payload);
	},
	postAgendaNapsItem(context, payload) {

		if (payload.startTime.length === 5) {
			payload.startTime = `${ payload.startTime }:00`;
		}

		if (payload.endTime.length === 5) {
			payload.endTime = `${ payload.endTime }:00`;
		}

		context.commit('POST_AGENDA_NAPS_ITEM', payload);

	},
	putAgendaNapsItem(context, payload) {

		if (payload.startTime.length === 5) {
			payload.startTime = `${ payload.startTime }:00`;
		}

		if (payload.endTime.length === 5) {
			payload.endTime = `${ payload.endTime }:00`;
		}

		context.commit('PUT_AGENDA_NAPS_ITEM', payload);

	},
	postAgendaEventualMedicineItem(context, payload) {

		if (payload.time.length === 5) {
			payload.time = `${ payload.time }:00`;
		}

		context.commit('POST_AGENDA_EVENTUAL_MEDICINE_ITEM', payload);

	},
	putAgendaEventualMedicineItem(context, payload) {
		context.commit('PUT_AGENDA_EVENTUAL_MEDICINE_ITEM', payload);
	},
	postAgendaEvacuationItem(context, payload) {
		context.commit('POST_EVACUATION_ITEM', payload);
	},
	putAgendaEvacuationItem(context, payload) {
		context.commit('PUT_EVACUATION_ITEM', payload);
	},
	putAgendaRestockingItem(context, payload) {
		context.commit('PUT_RESTOCKING_ITEM', payload);
	},
	putAgendaScheduledHomework(context, payload) {

		context.commit('PUT_AGENDA_SCHEDULED_HOMEWORK', {
			index: payload.target.dataset.index,
			value: payload.target.value
		});

	},
	putAgendaExclusiveHomework(context, payload) {
		context.commit('PUT_EXCLUSIVE_HOMEWORK', payload);
	},
	putCompletionStatus(context, payload) {
		context.commit('PUT_COMPLETION_STATUS', payload);
	},
	copyHomeworkbyClass(context, payload) {
		context.commit('PUT_EXCLUSIVE_HOMEWORK_ID', payload);
	},
	pushReplacementItem(context, payload) {

		const payloadClone = cloneDeep(payload);
		payloadClone.dueDate = moment(payloadClone.dueDate).format('YYYY-MM-DD');

		context.commit('PUSH_REPLACEMENT_ITEM', payloadClone);

	},
	putReplacementItem(context, payload) {
		context.commit('PUT_REPLACEMENT_ITEM', payload);
	},
	removeReplacementItem(context, payload) {
		context.commit('DELETE_REPLACEMENT_ITEM', payload);
	}
};



// WEBPACK FOOTER //
// ./sources/app/agenda/actions.js